import React from "react"

import { ContentTag, connect } from "scrivito"
import { FooterObjClass } from "scrivito/Objs/Footer/FooterObjClass"
import { getCurrentSiteID } from "shared/lib/getCurrentSiteID"

import { FooterView } from "./FooterView"

export const Footer = React.memo(
  connect(
    ({ footerRef }: { footerRef?: React.ForwardedRef<HTMLDivElement> }) => {
      const footerObj = FooterObjClass.onSite(getCurrentSiteID()).all().first()

      return (
        <FooterView
          ref={footerRef}
          address={
            <ContentTag
              content={footerObj}
              attribute="contactDetailsWidget"
              className="footer__address"
            />
          }
          socials={
            <ContentTag
              content={footerObj}
              attribute="socialsWidget"
              className="footer__social-media"
            />
          }
          topLinks={
            <ContentTag
              content={footerObj}
              attribute="topLinks"
              className="footer__top-links"
            />
          }
          bottomLinks={
            <ContentTag
              content={footerObj}
              attribute="bottomLinks"
              className="footer__bottom-links"
            />
          }
        />
      )
    }
  )
)
